import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface FormPhoneInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  touched?: boolean;
  id?: string;
  name?: string;
  disabled?: boolean;
}

export const FormPhoneInput: React.FC<FormPhoneInputProps> = ({
  label,
  value,
  onChange,
  error,
  touched,
  id = 'phone',
  name = 'phone',
  disabled = false,
}) => {
  const hasError = touched && error;

  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className={`relative ${hasError ? 'phone-input-error' : ''}`}>
        <PhoneInput
          country={'cl'}
          value={value}
          onChange={onChange}
          disabled={disabled}
          inputProps={{
            name,
            id,
            required: true,
          }}
          containerClass={`${hasError ? 'phone-input-error' : ''}`}
          inputClass={`
            w-full px-4 py-2 border rounded-lg transition-colors duration-200
            focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-100 disabled:text-gray-500
            ${hasError ? 'border-red-500' : 'border-gray-300'}
          `}
          buttonClass={`border-gray-300 rounded-l-lg ${hasError ? 'border-red-500' : ''}`}
          dropdownClass="phone-dropdown"
          searchClass="phone-search"
          enableSearch={true}
          disableSearchIcon={false}
          searchPlaceholder="Buscar país..."
        />
      </div>
      <AnimatePresence>
        {hasError && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            id={`${id}-error`}
            className="mt-1 text-sm text-red-600"
            role="alert"
          >
            {error}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FormPhoneInput;
